import { firestore } from '../utilities/firebase'
import errorTypes from '../enums/errorTypes'
import getCurrentUid from '../utilities/getCurrentUid'
import { errorOfType } from '../utilities/Errors'

const addImageToUserProfileByUrl = async ({ url }) => {
	try {
		const uid = getCurrentUid()

		const userProfilesCollRef = firestore.collection('userProfiles')
		// get user doc
		const userProfileDocRef = userProfilesCollRef.doc(uid)
		const userProfileDocSnap = await userProfileDocRef.get()
		// check for errors
		if (!userProfileDocSnap.exists) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { uid }))
		}
		// add image to collection
		await userProfileDocRef.collection('uploadedImages').doc().set({ url })

		// output
		return { url }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, url, exception)
	}
}

export default addImageToUserProfileByUrl



// WEBPACK FOOTER //
// ./src/dataservices/addImageToUserProfileByUrl.js